export default __webpack_public_path__ + "static/media/Profile.160df48b.png";